import ky from 'ky';
import { ENV } from 'src/utils/env';

export interface EditZoneNotesPromiseParam {
  display_id: string;
  zone_type: 'detection_zone' | 'presence_zone';
  zone_note_data: {
    last_updated: string;
    block_data: unknown;
  };
}

export const editZoneNotesPromise = async (param: EditZoneNotesPromiseParam) => {
  try {
    await ky
      .post(`${ENV.FRONTEND_API_URL}/edit_zone_notes`, {
        body: JSON.stringify(param),
      })
      .json();
  } catch (error) {
    console.error(error);
  }

  return true;
};
